module.exports = __webpack_public_path__ + "static/media/brainstorm@x10.033427ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/taptile/src/brainstorm@x10.png
// module id = 429
// module chunks = 0